module.exports = __webpack_public_path__ + "static/media/button_selected.6fb0f9e9.png";